import { SelectItem } from "@heroui/react";
import { AutocompleteMultiple } from "../AutocompleteMultiple";
import normalizedMachineNameSort from "../../utils/normalized-machine-name-sort";
import { Machine } from "../../types";
import { CoolHeading } from "../CoolHeading";

export function MachineAutocomplete({
  machines,
  selectedMachines,
  setSelectedMachines,
}: {
  machines: Machine[];
  selectedMachines: number[];
  setSelectedMachines: (machines: number[]) => void;
}) {
  const orderedSelectedMachines = normalizedMachineNameSort(
    machines.filter((m) => (selectedMachines || []).includes(m.machineGroupId))
  );

  return (
    <AutocompleteMultiple
      className="normal-case lg:w-1/2"
      label={
        <CoolHeading variant="fixed" className="mt-1 uppercase">
          Machines
        </CoolHeading>
      }
      items={machines.map((m) => ({
        id: m.machineGroupId.toString(),
        name: m.machineGroupName,
      }))}
      selectedKeys={orderedSelectedMachines.map((m) =>
        m.machineGroupId.toString()
      )}
      onSelectionChange={(key) => {
        setSelectedMachines(Array.from(key).map((id) => parseInt(id, 10)));
      }}
    >
      {normalizedMachineNameSort(machines).map((machine) => (
        <SelectItem
          textValue={machine.machineGroupName.toString()}
          key={machine.machineGroupId}
        >
          {machine.machineGroupName}
        </SelectItem>
      ))}
    </AutocompleteMultiple>
  );
}
